import {
    Button,
    TextField,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

function GewichtAddDialog({ open, onClose, formData, onInputChange, loading, onSubmit }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>Gewicht eintragen</DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937', pt: 2 }}>
                <Grid container spacing={2}>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Gewicht (kg)"
                            name="gewicht"
                            type="number"
                            value={formData.gewicht}
                            onChange={onInputChange}
                            inputProps={{ step: 0.1, min: 0 }}
                            disabled={loading}
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Datum"
                            name="datum"
                            type="date"
                            value={formData.datum}
                            onChange={onInputChange}
                            InputLabelProps={{ shrink: true }}
                            disabled={loading}
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Notiz (optional)"
                            name="notiz"
                            value={formData.notiz}
                            onChange={onInputChange}
                            disabled={loading}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button onClick={onClose} sx={{ color: '#93c5fd' }} disabled={loading}>Abbrechen</Button>
                <Button
                    fullWidth
                    variant="contained"
                    startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
                    onClick={onSubmit}
                    disabled={loading}
                    sx={{
                        background: "linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)",
                        borderRadius: '16px',
                        textTransform: 'none'
                    }}
                >
                    {loading ? 'Wird gespeichert...' : 'Gewicht speichern'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GewichtAddDialog;
